import Vue from 'vue';
import { upperFirst, camelCase } from 'lodash';

window.$ = window.jQuery = require('jquery');

export default function importLocalComponents(requireComponent)
{
    requireComponent.keys().forEach((fileName) => {

        const componentConfig = requireComponent(fileName);
        const filenameSplit = fileName.split('/');
        const componentName = upperFirst(
            camelCase(
                filenameSplit[filenameSplit.length - 1].replace(/\.\w+$/, '')
            )
        );

        Vue.component(componentName, componentConfig.default || componentConfig)
    });
}

importLocalComponents(require.context('./elements', true,  /[\w-]+\.vue$/));